export default function SummarizerProgressCard({ data, loading }) {
  return (
    <div className={`card bg-base-100 shadow-xl widget-card ${loading ? 'loading' : ''}`}>
      <div className="card-body">
        <h2 className="card-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          Summarizer Progress
        </h2>
        
        {loading && !data ? (
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-md"></span>
          </div>
        ) : data ? (
          <div className="space-y-4">
            {/* Overall Progress */}
            <div>
              <div className="flex justify-between mb-2">
                <span className="text-sm font-medium">Overall Progress</span>
                <span className="text-sm text-base-content/60">
                  {data.progress || 0}%
                </span>
              </div>
              <progress 
                className="progress progress-primary w-full" 
                value={data.progress || 0} 
                max="100"
              ></progress>
            </div>

            {/* Stats */}
            <div className="stats shadow">
              <div className="stat place-items-center">
                <div className="stat-title">Total Chunks</div>
                <div className="stat-value">{data.total_chunks || 0}</div>
              </div>
              
              <div className="stat place-items-center">
                <div className="stat-title">Processed</div>
                <div className="stat-value text-primary">{data.processed_chunks || 0}</div>
              </div>
              
              <div className="stat place-items-center">
                <div className="stat-title">Summary Size</div>
                <div className="stat-value text-secondary">
                  {data.summary_size ? `${(data.summary_size / 1024).toFixed(1)}KB` : '0KB'}
                </div>
              </div>
            </div>

            {/* Current Status */}
            {data.status && (
              <div className="alert alert-info">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>{data.status}</span>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}